import * as React from "react";
import {
    Alert,
    Button,
    ButtonGroup,
    Modal,
    ModalHeader,
    ModalBody,
    Input,
    UncontrolledAccordion,
    AccordionItem,
    AccordionHeader,
    AccordionBody,
} from "reactstrap";

import { Link, Outlet, useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretLeft } from '@fortawesome/free-solid-svg-icons';

// import { useDispatch } from "react-redux";
// import * as uuid from "uuid";

// import * as actions from "../storage/actions";
// import { useSettings } from "app/lib/settings";
// import { formatDate } from "app/lib/formatting";

import NewVectorLayerForm from "./vector-layer-form";
import UploadForm from "./upload-form";


export default function NewLayerModal({ onClose }) {
    const { workspaceId } = useParams();
    const navigate = useNavigate();

    if (!onClose) {
        const url = `/workspace/${workspaceId}`
        onClose = () => { navigate(url) };
    }

    return (
        <Modal isOpen toggle={onClose} size="xl">
            <ModalHeader toggle={onClose}>
                Create new layer
            </ModalHeader>
            <ModalBody>
                <Outlet />
            </ModalBody>
        </Modal>
    );
}


function GoBack() {
    const navigate = useNavigate();
    return (
        <div className="mb-3">
            <Button
                color="link"
                onClick={() => navigate("..")}
                className="p-0 m-0 text-muted text-decoration-none"
            >
                <FontAwesomeIcon icon={faCaretLeft} />
                {" "}Back
            </Button>
        </div>
    );
}


export function NewLayerIndexUI() {
    return (
        <div className="d-flex flex-column align-items-stretch">
            <div className="text-center my-3">
                <Button tag={Link} to="geojson" size="lg" color="success">
                    Create a new vector layer
                </Button>
                <div className="my-2 text-muted">
                    Data added to the new layer will be stored in your workspace as GeoJSON.
                </div>
            </div>
            <div className="text-center my-3">or</div>
            <div className="text-center my-3">
                <Button tag={Link} to="upload" size="lg" color="primary">
                    Upload .geojson file
                </Button>
            </div>
        </div>
    );
}


export function NewLayerGeojsonUI({ onComplete, onCancel }) {
    return (
        <>
            <GoBack />
            <NewVectorLayerForm
                onComplete={onComplete}
                onCancel={onCancel}
            />
        </>
    );
}


export function NewLayerUploadUI({ onComplete, onCancel }) {
    return (
        <div>
            <GoBack />
            <UploadForm
                onComplete={onComplete}
                onCancel={onCancel}
            />
        </div>
    );
}
